<ng-container *transloco="let t">
  @for (customField of sanitizedCustomFieldDetails(); track customField) {
    <div class="order-section-item">
      <div class="order-section-item-title">{{ customField.name }}</div>
      <div class="order-section-item-value">{{ customField.value }}</div>
    </div>
  }
</ng-container>
